import {connect} from '@gisatcz/ptr-state';

import Action from '../../../../state/Action';
import Select from '../../../../state/Select';

import presentation from './presentation';

const mapStateToProps = (state, ownProps) => {
	return {
		types: Select.app.getLocalConfiguration(
			state,
			'data.interferometry.tracks.types'
		),
		orbits: Select.app.getLocalConfiguration(
			state,
			'data.interferometry.tracks.orbits'
		),
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		onTypeChange: key => {
			dispatch(Action.selections.setActiveSelectionFeatureKeysFilterKeys([])); // clear selection
			dispatch(
				Action.app.setLocalConfiguration(
					'data.interferometry.tracks.types.activeKey',
					key
				)
			);
			dispatch(
				Action.specific.eo4sdDrrInsarVietnam20.useInterferometryMapData()
			);
		},
		onOrbitsChange: keys => {
			dispatch(
				Action.app.setLocalConfiguration(
					'data.interferometry.tracks.orbits.activeKeys',
					keys
				)
			);
			dispatch(
				Action.specific.eo4sdDrrInsarVietnam20.useInterferometryMapData()
			);
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(presentation);
